import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { Device } from '@capacitor/device';
import { App } from '@capacitor/app';
import RealtimeService from 'sync/RealtimeService';

export const deviceInfo = {
	manufacturer: null,
	model: null,
	identifier: null,
};

const ready = ( async function()
{
	if( Capacitor.isNativePlatform() )
	{
		try
		{
			// Configuration de la barre de statut selon la plateforme
			if( Capacitor.getPlatform() === 'android' )
			{
				await StatusBar.setOverlaysWebView({ overlay: false });
				await StatusBar.setBackgroundColor({ color: '#111111' });
				await StatusBar.setStyle({ style: Style.Dark });
			}
			else
			{
				await StatusBar.setStyle({ style: Style.Light });
				await StatusBar.setBackgroundColor({ color: '#009847' });
			}
		}
		catch( e )
		{
			console.warn( 'StatusBar init failed', e );
		}

		try
		{
			// Masquer le splash natif une fois l'app prête
			await SplashScreen.hide();
		}
		catch( e )
		{
			console.warn( 'SplashScreen hide failed', e );
		}

		try
		{
			// Background : coupe SSE ; foreground : sync puis reconnecte
			App.addListener( 'appStateChange', function( state )
			{
				if( !state.isActive )
				{
					RealtimeService.pause();
					return;
				}

				if( typeof app !== 'undefined' && app.is && app.is( 'ready' ) )
				{
					RealtimeService.resume();
				}
			} );
		}
		catch( e )
		{
			console.warn( 'App lifecycle listener failed', e );
		}
	}

	try
	{
		// Infos appareil pour les headers HTTP
		const info = await Device.getInfo();
		const id = await Device.getId();
		deviceInfo.manufacturer = info.manufacturer;
		deviceInfo.model = info.model;
		deviceInfo.identifier = id.identifier;
	}
	catch( e )
	{
		console.warn( 'Device info unavailable', e );
	}
} )();

export default ready;
